import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import i18n from './i18n'

Vue.config.productionTip = false

if (document.getElementById('app')) {
  new Vue({
    i18n,
    render: h => h(App)
  }).$mount('#app')
}
